import groq from 'groq'

export function socials() {
	return groq`*[_type == 'sharedContent'][0] {
   "socials": socials.list
},
`
}
